var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardHeader',{attrs:{"title":_vm.$route.name}}),_c('div',{staticClass:"container-fluid mt--6"},[_c('BasicInformationCard',{attrs:{"businessData":_vm.business},on:{"updatedProfile":_vm.getBusiness}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }